export default {
  root: {
    display: 'flex',
    alignItems: 'center',
  },
};
